import s from '../styles/modules/Classes.module.scss';
import Calendar from '../components/Calendar';
import ClassesInfo from '../components/ClassesInfo';
import { CalendarDays, ClipboardList } from 'lucide-react';
import BreadcrumbComponent from '../components/BreadcrumbComponent';

const Classes = () => {
  return (
    <div className={s.wrapper_classes}>
      <div className="mt-8 space-y-6 rounded-lg bg-white p-3">
        <BreadcrumbComponent link={'Занятия'} />
        <div className="flex flex-col gap-8">
          <div>
            <div className="mb-4 flex items-center gap-2">
              <CalendarDays className="h-5 w-5 text-primary" />
              <h2 className="text-xl font-medium text-gray-900">Календарь</h2>
            </div>
            <div className="flex justify-start overflow-x-auto md:overflow-x-visible">
              <Calendar />
            </div>
          </div>
          <div>
            <div className="mb-4 flex items-center gap-2 min-w-[170px]">
              <ClipboardList className="h-5 w-5 text-primary" />
              <h2 className="text-xl font-medium text-gray-900">Ваши занятия</h2>
            </div>
            <div className="max-w-[350px] mx-auto md:ml-0 md:w-[350px] overflow-x-auto md:overflow-x-visible">
              <ClassesInfo />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Classes;
